<template>
  <div>
  
    <div v-if="this.$cookie.get('enGoSimulCookie')" class="headerConnect home"
    fluid
    >
    <div class="row pt-2 pb-2 pl-5" style="background:#F5EFDF;">
      <div class="col-6">Connecté en tant que <a :href="this.$apiBasePath+'/admin'" target="_blank">{{ this.$cookie.get('enGoSimulCookie') }}</a></div>
      <div class="col-6 text-align-right pr-5"><a :href="this.$apiBasePath+'/admin'" target="_blank">Dashboard</a> | <a :href="this.$apiBasePath+'/logout'" target="_blank">Déconnexion</a></div>
    </div>
  </div>
  <div class="eg-home row">
    <div
        class="col-12 col-md-6 col-lg-6 offset-md-1"
    >
      <eg-logo class="eg-logo"/>

      <div class="eg-home__title">
        <h1 class="d-none d-md-block">Estimez les futures économies<br><span class="txtOrange">de votre installation solaire</span></h1>
        <h1 class="d-md-none">Estimez les futures économies <span class="txtOrange">de votre installation solaire</span></h1>
      </div>

      <p class="d-md-block mt-5 mb-8" style="font-size: 21px; font-weight: normal;">
        {{ txtp }}
      </p>

      <div class="row no-gutters">
        <div class="col-12 d-flex justify-center justify-md-start">
          <eg-btn
              text="Simulation gratuite >"
              icon-class="eg-icon-next"
              rounded="false"
              class="bt-home"
              @click="next('Chauffage')"
          />
        </div>
      </div>

      <p class="text-align-right containerEldo">
        <img
            class="center-block valign-sub pr-1"
            :src="require('@/assets/images/home/star-eldo.png')"
            :alt="txtH1"
        />
        Noté 4.8/5 sur Eldo
      </p>

      <div
          class="d-flex d-md-none
            col-12
            justify-center
            mt-9 mb-6"
      >
        <img
            :src="require('@/assets/images/home/accueil-format-mobile.png')"
            class="imgHome"
            :alt=txtH1
        />
      </div>
    </div>

    <div class="d-none d-md-block col-md-5 offset-lg-1 eg-col-padding-y imgHome">
        <img
          v-if="partner === 'sol-et-moi'" 
          :src="require('@/assets/images/home/accueil-format-web-sol-et-moi.png')"
          :alt=txtH1
        />
        <img
          v-else
          :src="require('@/assets/images/home/accueil-format-web.png')"
          :alt=txtH1
        />
    </div>

  </div>
      
</div>

</template>

<script>
import EgBtn from '@/components/base/EgBtn'
import EgLogo from '@/components/special/EgLogo'
import themeServices from '@/services/themeServices'
import Vue from 'vue'
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

export default {
  name: "home",
  data(){
    return {
      txtH1: 'Estimez les futures économies de votre installation solaire',
      txtp: 'En installant des panneaux solaires sur le toit de votre maison, réduisez votre facture d’électricité et générez des économies en toute sérénité !',
      txtaltEldo: '4.8/5 sur Eldo',
      partner: themeServices.getTheme(),
    }
  },
  components: {
    EgBtn,
    EgLogo
  },
  methods: {
    cleanURL(url) {
      const urlObj = new URL(url);
      return urlObj.origin + urlObj.pathname
    },
    cleanHomeLink(){
      const self = this
      setTimeout(function(){
        let links = null
        links = document.querySelectorAll('.headerConnect.home a')
        if(links){
          for(let i = 0; i < links.length; i++){
            links[i].href = self.cleanURL(links[i].href)
          }
        }
      },500)
    }
  },
  mounted(){
    this.cleanHomeLink()
  }
}
</script>

<style lang="scss" scoped>
.valign-sub{
  vertical-align: sub;
}

.containerEldo{
  width: 340px;
}
.eg-home {
  position: relative;
  
    padding-top: 15%;
    height: 100vh;
  
  .eg-home__title {
    line-height: 26px;
    margin-top: 40px;
    color: var(--v-primary-base);
    font-family: "Baloo Tamma 2", serif;
  }

  .eg-home__title .txtOrange{
    font-family: "Baloo Tamma 2", serif;
  }

  .eg-home__title:after {
    content: ' ';
    height: 4px;
    width: 20px;
    position: absolute;
    background: #f8b131;
    background: -moz-linear-gradient(left,  #f8b131 0%, #ed6949 100%);
    background: -webkit-linear-gradient(left,  #f8b131 0%,#ed6949 100%);
    background: linear-gradient(to right,  #f8b131 0%,#ed6949 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8b131', endColorstr='#ed6949',GradientType=1 );
    border-radius: 2px;
    margin-top: 2px;
  }
 

  button.bt-home{
    height: 60px !important;
    border-radius: 0 !important;
    display: block;
    margin: 0 0 25px;
    padding: 0 70px !important;
    text-transform: none !important;
  }

  .imgHome img{
    position: relative;
    z-index: 1;
    max-width: 500px;
    margin-left: 40px;
  }
  .imgHome:before{
    content: '';
    background: #ffe1bc;
    height: calc(100% + 115px);
    width: 100% !important;
    position: absolute;
    top: -61px;
    margin-left: 30%;
    z-index: 0;
  }
}
.headerConnect{
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.txtOrange{
  background: linear-gradient(0deg,#f8b131, #ed6949);
  background: -webkit-linear-gradient(0deg,#f8b131, #ed6949);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .eg-home{
    padding-top: 0;
  }
  @-moz-document url-prefix() {
    .eg-home{
      width: calc(100% - 50px) !important;
    }
  }
  .headerConnect.home{
    position: relative;
  }
  img.imgHome{
    width: 100%;
  }
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .eg-home {
    padding-top: calc((90vh - 500px)/2);
    height: 90vh;

    .eg-home__title {
      margin-top: 70px;
    }
  }

  .eg-logo {
    width: 280px;
  }
}
@media screen and (max-width: 1023px) {
  .containerEldo{
    width: 100%;
    text-align: center;
  }
}

//Iphone XR and old others Iphones
@media only screen 
    and (device-width : 414px) 
    and (-webkit-device-pixel-ratio : 2) { 
      .eg-home .txtOrange{
        display: block;
        margin: 0;
        padding: 0;
      }
    }

@media screen and (max-width: 360px) {
  .eg-home {
    width: calc(100vw - 5%);
    .engo-logo{
      width: 150px !important;      
    }

    .eg-home__title{
      margin-top: 20px !important;
    }
  }
  .bt-home{
    transform: scale(.8);
    transform-origin: top center;
  }
  .containerEldo{
    transform: scale(.8);
    transform-origin: top center;
  }
}
</style>